import { render, staticRenderFns } from "./FacePhoto.vue?vue&type=template&id=6f099af0&scoped=true&"
import script from "./FacePhoto.vue?vue&type=script&lang=js&"
export * from "./FacePhoto.vue?vue&type=script&lang=js&"
import style0 from "./FacePhoto.vue?vue&type=style&index=0&id=6f099af0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f099af0",
  null
  
)

export default component.exports